import React, { useCallback, useState } from 'react';
import moment from 'moment';
import { useQuery } from '@apollo/client';
import { QueryTableResponse } from 'global';
import { DateFormats } from 'constants/common';
import { ChangelogFiltersInput, ChangelogListing } from 'components/shared/changelog';

import { ChangesCell } from './ChangesCell';
import { BPFAPINameSpase } from '../../types';
import { bpfAPI, BpfChangelogViewModel } from '../../api';

interface Props {
  parentId?: string;
}

export const BpfChangelogListing = ({ parentId }: Props) => {
  const [pagination, setPagination] = useState({ page: 1, perPage: 25 });
  const [filters, setFilters] = useState<ChangelogFiltersInput | undefined>(undefined);

  const { data, previousData, loading, refetch } = useQuery<BPFAPINameSpase<QueryTableResponse<BpfChangelogViewModel>>>(
    bpfAPI.changelogGetList,
    {
      notifyOnNetworkStatusChange: true,
      variables: {
        input: {
          pagination,
          ...(filters ? { filters } : {}),
          ...(parentId ? { id: parentId } : {}),
        },
      },
    }
  );

  const handleFiltersChanged = useCallback((nextFilters: ChangelogFiltersInput | undefined) => {
    setFilters(nextFilters);
    setPagination(prev => ({ ...prev, page: 1 }));
  }, []);

  const items = data?.bpf?.result?.items ?? previousData?.bpf?.result?.items ?? [];

  return (
    <ChangelogListing<BpfChangelogViewModel>
      list={items}
      loading={loading}
      refetch={refetch}
      pagination={pagination}
      onPaginationChanged={setPagination}
      onFiltersChanged={handleFiltersChanged}
      total={data?.bpf?.result?.pagination?.total ?? 0}
      changesCell={({ changes, changeType }) => <ChangesCell changeType={changeType} changes={changes} />}
      mapper={items =>
        items.map(log => ({
          id: log.id,
          changes: log.changes,
          changeType: log.changeType,
          modifiedBy: log.modifiedBy?.fullName ?? '—',
          createdDateTime: moment(log.createdDateTime).format(DateFormats.DateTimeMedium24Hour),
        }))
      }
    />
  );
};
